import { borderColorPalette as colorPalette } from '@atlaskit/adf-schema';
import { DEFAULT_BORDER_COLOR } from './common';
import getColorMessage from './getColorMessage';
import paletteMessages from './paletteMessages';
var borderColorPalette = [];
colorPalette.forEach(function (label, color) {
  var key = label.toLowerCase().replace(' ', '-');
  var message = getColorMessage(paletteMessages, key);
  borderColorPalette.push({
    value: color,
    label: label,
    border: DEFAULT_BORDER_COLOR,
    message: message
  });
});
export default borderColorPalette;